'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingDots = function LoadingDots(props) {
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.loaderOuter + ' ' + (props.centered ? _style2.default.centered : '') },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.loaderInner },
			_react2.default.createElement('div', { className: _style2.default.circle }),
			_react2.default.createElement('div', { className: _style2.default.circle }),
			_react2.default.createElement('div', { className: _style2.default.circle }),
			_react2.default.createElement('div', { className: _style2.default.circle })
		)
	);
};

LoadingDots.propTypes = {
	centered: require('react').PropTypes.any
};
LoadingDots.displayName = 'LoadingDots';

LoadingDots.defaultProps = {};

exports.default = LoadingDots;